/**
 * Pure capability presentation helpers used by Portal Support S7-C UI.
 * Keep in sync with server capabilities DTO semantics.
 */
export function portalSupportWriteControls(capabilities = {}, status) {
  const caps = capabilities || {};
  return {
    canReply: Boolean(caps.can_reply),
    canUpload: Boolean(caps.can_upload_attachment),
    canAddInvolved: Boolean(caps.can_add_involved),
    showReopenHint: Boolean(caps.can_reply) && status === 'resolved',
    showClosedHint: status === 'closed',
    showExpiredHint:
      status !== 'closed'
      && !caps.can_reply
      && !caps.can_upload_attachment
      && !caps.can_add_involved,
  };
}

export function portalSupportCreateControls({ hasCreatePermission, canCreate }) {
  return {
    showCreateAction: Boolean(hasCreatePermission),
    createEnabled: Boolean(hasCreatePermission && canCreate),
    showInactiveSupportHint: Boolean(hasCreatePermission && !canCreate),
  };
}
